var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVerticalEllipsis = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 5.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM9 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
  fill: "#202426"
})));
export default __webpack_public_path__ + "static/verticalEllipsis.[git-hash].svg";
export { SvgVerticalEllipsis as ReactComponent };